import PointHttpClientService from "@/CommonVueCore/src/services/httpService/axios/pointHttpClientService.js";

// TranslateApi standalone mikroservis (https://localhost:62313 dev). Diger
// projelerde de yeniden kullanilacagindan ayri service client tutuluyor;
// gateway namespace altina alinacaksa appsettings'teki TranslateApiUrl'i
// `${CProXApiServiceClientUrl}/translate` yap.
export class TranslateApiServiceClient extends PointHttpClientService {
    constructor({ baseUri, requestInterceptorFn, cancelToken }) {
        super({
            baseUrl: baseUri,
            requestInterceptorFn: requestInterceptorFn,
            cancelToken: cancelToken,
        });
    }
}
